import { createFileRoute } from "@tanstack/react-router";

import { AuthGate } from "@/components/AuthGate";
import { TrashView } from "@/components/TrashView";

export const Route = createFileRoute("/trash")({
  component: function TrashPage() {
    return (
      <AuthGate>
        <TrashView />
      </AuthGate>
    );
  },
});
